import { ProposalEntity, ProposalStatus } from '@modules/clients/entities/client/api/dto/clientProposal.dto';

export const ProposalDomain = {
  // eslint-disable-next-line max-len
  canDuplicate: (proposal: ProposalEntity) => !proposal.client_external_id && proposal.status === ProposalStatus.GENERATED,

  canEdit: (proposal: ProposalEntity) => !proposal.editable_until || new Date(proposal.editable_until) > new Date(),

  isGenerated: (proposal: ProposalEntity) => proposal.status === ProposalStatus.GENERATED,
};
